import {
    themes,
    innerThemes,
} from '../vars/themes';

const setThemes = () => {
    const $html = document.querySelector('html');
    const $style = $html.appendChild(document.createElement('style'));
    let styles = '';

    const setTheme = (id) => {
        let vars = '';
        for (const [key, value] of Object.entries(themes[id])) {
            vars += `--color-${key}:${value};`;
        }
        return vars;
    }

    for (const [id, set] of Object.entries(themes)) {
        styles += `[data-theme='${id}'] {${setTheme(id)}}`;
    }

    for (const [id, set] of Object.entries(innerThemes)) {
        for (const [key, value] of Object.entries(set)) {
            styles += `[data-theme='${id}'] [data-inner-theme='${key}'] {${setTheme(value)}}`;
        }
    }

    $style.textContent = styles;
}

document.addEventListener('DOMContentLoaded', setThemes);

export default setThemes;
